import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react"
import { BiQrScan, BiSolidEdit } from "react-icons/bi"
import { GoTasklist } from "react-icons/go"
import { IoArrowForwardOutline, IoCloseOutline } from "react-icons/io5"
import { LuMessageCircleQuestion } from "react-icons/lu"
import { MdOutlineArrowForwardIos } from "react-icons/md"
import { useNavigate } from "react-router-dom"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import { EventDocData } from "@letshang/constants"
import { ROUTES } from "src/App"

import {
  TDeviceType,
  useDeviceTypeByWidth,
} from "@fuse/customHooks/useDeviceTypeByWidth"

import DownloadAppModalV4, {
  DownloadAppModalHandle,
} from "./DownloadAppModalV4"

export interface SettingsBottomSheetHandle {
  openModal: () => void
  closeModal: () => void
}

const SettingsBottomSheet = forwardRef<
  SettingsBottomSheetHandle,
  {
    eventId: string
    eventDocData: EventDocData
    onGuestList: () => void
  }
>(({ eventId, eventDocData, onGuestList }, ref) => {
  const [isVisible, setIsVisible] = useState(false)
  const navigate = useNavigate()
  const modalRef = useRef<DownloadAppModalHandle>(null)
  const deviceType = useDeviceTypeByWidth()
  const isMobileDevice = deviceType === TDeviceType.MOBILE

  const onOpenDownloadAppModal = () => {
    modalRef.current?.openModal()
  }

  const optionsList = [
    {
      title: "Edit",
      icon: <BiSolidEdit size={20} />,
      isDisabled: false,
      onPress: () => {
        navigate(ROUTES.EDIT_EVENT.replace(":eventId", eventId), {
          state: {
            eventDocData: eventDocData,
          },
        })
      },
    },
    {
      title: "Guest List",
      icon: <GoTasklist size={20} />,
      isDisabled: false,
      onPress: () => {
        onGuestList()
        setIsVisible(false)
      },
    },
    {
      title: "Add Questionnaires",
      icon: <LuMessageCircleQuestion size={20} />,
      isDisabled: true,
      onPress: () => {
        console.log("onPress")
        onOpenDownloadAppModal()
      },
    },
    {
      title: "Text Blasts",
      icon: <BiQrScan size={20} />,
      isDisabled: true,
      onPress: () => {
        console.log("onPress")
        onOpenDownloadAppModal()
      },
    },
    {
      title: "Scan Tickets",
      icon: <BiSolidEdit size={20} />,
      isDisabled: true,
      onPress: () => {
        console.log("onPress")
        onOpenDownloadAppModal()
      },
    },
  ]

  // Get the registration details for the description field

  useImperativeHandle(ref, () => ({
    openModal: () => {
      setIsVisible(true)
    },
    closeModal: () => {
      setIsVisible(false)
    },
  }))

  if (!isVisible) return null

  return (
    <div
      className={` ${"fixed inset-0 flex justify-center bg-black bg-opacity-50 z-[100] items-end md:items-center place-items-center"} `}
      onClick={(e) => {
        // Only close if clicking the backdrop (the outer div itself)
        if (e.target === e.currentTarget) {
          setIsVisible(false)
        }
      }}
    >
      <BlurWrapper
        overlayOpacityDefault="60"
        blurIntensityDefault="lg"
        className="w-full md:max-w-sm !bg-gray-500/10 rounded-t-2xl md:rounded-2xl p-6 relative flex flex-col cursor-auto place-content-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative flex flex-col items-center justify-between gap-4">
          {optionsList.map((item, index) => (
            <div
              key={index}
              className="flex w-full items-center justify-center gap-4"
              onClick={item.onPress}
            >
              <div
                className={` p-2 bg-white/10 rounded-lg ${
                  !item.isDisabled ? "text-white" : "text-white/35"
                }`}
              >
                {item.icon}
              </div>
              <div
                className={`flex-1 text-white text-left ${
                  !item.isDisabled ? "text-white" : "text-white/35"
                }`}
              >
                {item.title}
              </div>
              <div>
                <MdOutlineArrowForwardIos
                  className={`${!item.isDisabled ? "text-white" : "text-white/35"}`}
                  size={20}
                />
              </div>
            </div>
          ))}
        </div>
      </BlurWrapper>
      <DownloadAppModalV4 ref={modalRef} showOnTop={!isMobileDevice} />
    </div>
  )
})

export default SettingsBottomSheet
